import {formatFilterValue} from '../../../Form/actions/filters';
import {Form} from '../../../../stores/Form/Form';
import {priority} from '@priority-software/priority-proto-api/lib';
import {getNetFormDname} from '../../../../_shared/GWTBridge/invoke/genPage';
import {selectCompanyStore} from '../../../../features/SelectCompanyDlg/SelectCompanyStore';

export const createFiltersFromExposedKeys = (
    keys: Array<{columnName: string; value: string}>,
    form: Form
) => {
    if (keys.length === 0) return null;

    const filters = keys
        .map(key => {
            const column = form.getColumnByName(key.columnName);
            if (!column) return null;

            /*
             * exclude real value from filters. Because it might have formatted value with `parentheses` instead of origin
             * value with `minus` for negative field value
             */
            if (column.Type === priority.netitems.form.ColumnType.Real) {
                return null;
            }
            return new priority.netitems.form.Filter({
                Condition: [
                    new priority.netitems.form.Condition({
                        ColumnID: column?.id,
                        Values: [formatFilterValue(form, column?.id, key.value)]
                    })
                ],
                Operator: priority.netitems.shared.LogicalOperator.Or
            });
        })
        .filter(Boolean);

    return filters.length > 0 ? filters : null;
};

/* EP-48264 Fix for a bug working with new-api and multi-companies
    Can be removed when issue is fixed in the BE
*/
export const trySetCurrentRowForMultiCompForms = (masterForm: Form) => {
    const multiEnvCol = masterForm.columns.find(col => col.MultiEnv);

    if (multiEnvCol) {
        const dName = getNetFormDname();
        const company = selectCompanyStore?.companies?.find(comp => comp.dname === dName);
        const companyTitle = company?.title;
        const currentRecord = masterForm.records.find(record => {
            return record.fieldsMap.get(multiEnvCol.ID as number)?.origValue === companyTitle;
        });
        if (currentRecord) {
            masterForm.setCurrentRow(currentRecord?.recordIndex);
        }
    }
};
